// extracted by mini-css-extract-plugin
module.exports = {"tabularNumber":"TabularNumber_tabularNumber__3hHMz"};